const FilePicker = {
    props: {
        showNotification: {
            default: false,
            type: Boolean,
        },

        required: {
            default: false,
            type: Boolean,
        },

        notification: {
            default: "",
            type: String,
        },

        initialValue: {
            default: [],
            type: Array,
        },

        multiple: {
            default: false,
            type: Boolean,
        },
    },

    data() {
        return {
            error_message: null,

            valid: false,

            should_validate: false,

            allowedFormats: [
                "image/jpeg",
                "image/jpg",
                "application/pdf",
                // "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            ],

            allowedNameRegex: /^[a-zA-Zа-яА-Я0-9-.,_)(№ ]+$/,

            files: [],

            valid_files: [],
        };
    },

    computed: {
        inputClasses() {
            if (this.error_message) {
                return "invalid";
            }

            if (this.valid) {
                return "valid";
            }

            return "";
        },

        fileName() {
            if (this.files.length) {
                let files_names_string = "";

                this.files.forEach((file) => {
                    files_names_string += `${file.name} ,`;
                });

                return files_names_string.substring(0, files_names_string.length - 2);
            }

            return "Файлы не выбран";
        },
    },

    mounted() {
        if (this.initialValue) {
            this.files = this.initialValue;
        }
    },

    methods: {
        async onFilesChange(event) {
            this.should_validate = true;

            this.error_message = null;
            this.files = [];
            this.valid_files = [];
            this.valid = null;
            this.$emit("clear_files");

            this.files = Array.from(event.target.files);

            if (this.files.length) {
                this.files.forEach(async (file) => {
                    this.validate(file);

                    if (this.error_message) {
                        return;
                    }

                    const file_base64 = await this.toBase64(file);
                    const file_name = file.name;
                    const file_type = file.type;
                    const file_size = file.size;
                    this.valid_files.push({
                        name: file_name,
                        b64: file_base64,
                        type: file_type,
                        size: file_size,
                    });
                });

                this.$emit("files_picked", this.valid_files);
            }
        },

        async toBase64(file) {
            return await new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.readAsDataURL(file);

                reader.onload = () => {
                    resolve(reader.result);
                };

                reader.onerror = (error) => reject(error);
            });
        },

        clearFiles() {
            this.error_message = null;
            this.files = [];
            this.valid_files = [];
            this.valid = null;

            this.$refs["input"].value = "";

            this.$emit("clear_files");
        },

        validate(file) {
            if (!this.should_validate) {
                return;
            }

            if (this.required && !file.type) {
                this.error_message = `Поле обязательно для заполнения`;
                this.valid = false;
                return;
            }

            if (this.required) {
                if (!file.type) {
                    this.error_message = `${file.name}: не поддерживается`;
                    this.valid = false;
                    return;
                }
            }

            if (file.type && !this.allowedFormats.includes(file.type)) {
                this.error_message = `${file.name}: неподдерживаемый формат`;
                this.valid = false;
                return;
            }

            if (file.type && file.size > 5242880) {
                this.error_message = `${file.name}: слишком большой`;
                this.valid = false;
                return;
            }

            if (file.type && file.size < 25600) {
                this.error_message = `${file.name}: слишком маленький`;
                this.valid = false;
                return;
            }

            if (file.type && !this.allowedNameRegex.test(file.name)) {
                this.error_message = `${file.name}: недопустимые символы`;
                this.valid = false;
                return;
            }

            this.error_message = null;
            this.valid = true;
            this.$emit("valid");
        },

        hasValidationErrors() {
            this.should_validate = true;

            if (this.files.length) {
                this.files.forEach(async (file) => {
                    this.validate(file);

                    if (this.error_message) {
                        return;
                    }
                });
            } else {
                this.validate({
                    type: null,
                    size: null,
                    name: null,
                });
            }

            if (this.valid) {
                return false;
            }

            return true;
        },
    },

    template: /*html*/ `
    <div class="select-file" :class="[inputClasses, {disabled: disabled}]"> 
        <div class="select-file__block">
            <label>
                <input ref="input" type="file" autocomplete="off" @change="onFilesChange" :disabled="disabled" :multiple=multiple>
                <div class="select-file__btn">
                <svg class="icon icon-select-file-attach-icon">
                    <use :xlink:href="this.$bitrix.Application.instance.php_vars.images_folder_path + '/icons/sprite.svg#select-file-attach-icon'"></use>
                </svg><span>Выбрать файл</span>
                </div>
            </label>
            <div class="select-file__name">{{fileName}}</div>
            <a v-if="files.length" class="select-file__clear" href="javascript:;" @click="clearFiles">
                <svg class="icon icon-field-clear-icon">
                <use :xlink:href="this.$bitrix.Application.instance.php_vars.images_folder_path + '/icons/sprite.svg#field-clear-icon'"></use>
                </svg>
            </a>
            <div class="select-file__error" v-html="error_message"></div>
        </div>
        <div v-if="showNotification" class="select-file__notification">{{notification}}</div>
    </div>
  `,
};

export default FilePicker;
